let archiveResourceFilter = {};

(function (archiveResourceFilterApp) {
    const filterModel = {
        NodeId: 0,
        Tags: "",
        Languages: ""
    }

    let fromPopState = false;
    let blockPopstateEvent = true;
    const browserSupportsHistoryApi = window.history && 'pushState' in window.history;
    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            const currentPath = window.location.pathname;
            let query = "?";
            const queryArray = [];
            if (filterModel.NodeId && filterModel.NodeId > 1) {
                queryArray.push("id=" + filterModel.NodeId);
            }
            if (filterModel.Tags) {
                queryArray.push("tags=" + filterModel.Tags);
            }
            if (filterModel.Languages) {
                queryArray.push("languages=" + filterModel.Languages);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.CurrentPage = 1;
        filterModel.SearchTerm = "";
        if (window.location.search.length > 1) {
            for (let aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                const key = decodeURIComponent(aItKey[0]).toLowerCase();
                const val = decodeURIComponent(aItKey[1]);

                if (key === "id") {
                    filterModel.NodeId = val;
                } else if (key === "tags") {
                    filterModel.Tags = val;
                } else if (key === "languages") {
                    filterModel.Languages = val;
                }
            }
        }

        archiveResourceFilterApp.GetFilterResult();
    }

    archiveResourceFilterApp.GetFilterResult = function () {
        $.ajax({
            url: "/umbraco/surface/ArchiveResourceSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-archive-reources-wrapper").html(data);
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    function setFilter(filterToSet, selector) {
        const selected = [];
        $(`.shop-filters.${selector} input[type='checkbox']:checked`).each(function (i, tagItem) {
            const tag = $(tagItem).val();
            if (tag && tag.trim() !== "") {
                selected.push(tag);
            }
        });

        switch (filterToSet) {
            case "category":
                filterModel.Tags = selected.join(",");
                break;
            case "language":
                filterModel.Languages = selected.join(",");
                break;
            default:
            // code block
        }
    }

    $(document).ready(function () {

        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('id'))
            filterModel.NodeId = urlParams.get('id');

        if (urlParams.get('tags'))
            filterModel.Tags = urlParams.get('tags');

        if (urlParams.get('languages'))
            filterModel.Languages = urlParams.get('languages');

        $(document).on("click", ".js-search-button", function (e) {
            e.preventDefault();
            filterModel.NodeId = $(".js-archive-reources-wrapper").data("nodeid");
            setFilter("category", "js-category-filter");
            setFilter("language", "js-language-filter");
            archiveResourceFilterApp.GetFilterResult();
        });

        $(document).on("click", ".js-clear-button", function (e) {
            e.preventDefault();
            filterModel.NodeId = $(".js-archive-reources-wrapper").data("nodeid");
            filterModel.Tags = "";
            filterModel.Languages = "";
            $('input:checkbox').prop('checked', false)
            archiveResourceFilterApp.GetFilterResult();
        });
    });

})(archiveResourceFilter);
